import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import ClarityHeroField from '../ClarityHeroField';

type ChallengeClarityPaintProps = {
  rootSelector: string;
};

/**
 * Clarity filament paint for the full control_room challenge page.
 * Used on live variant C and the /challenges-clarity review route.
 */
export default function ChallengeClarityPaint({
  rootSelector,
}: ChallengeClarityPaintProps): React.ReactElement | null {
  const [host, setHost] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    const root = document.querySelector(rootSelector);
    const find = () => {
      const next = root?.querySelector('.chx-hero, .cpw-mast');
      return next instanceof HTMLElement ? next : null;
    };

    const updateHost = () => setHost(find());
    updateHost();

    // The experiment shell survives course/challenge navigation. Keep watching
    // for a replaced hero so the portal never remains on a detached element.
    const observer = new MutationObserver(updateHost);
    if (root) observer.observe(root, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [rootSelector]);

  if (!host) return null;

  const isCourseMast = host.matches('.cpw-mast');

  return createPortal(
    <ClarityHeroField
      className={isCourseMast ? 'course-clarity-review__field' : 'challenge-clarity-review__field'}
      copyKeep={isCourseMast ? 'left' : 'columns'}
      hostSelector={isCourseMast ? '.cpw-mast' : '.chx-hero'}
    />,
    host,
  );
}
